import React, { Component, useState } from 'react'
import Modal from '../component/general/Modal';
const heroImage = {
  backgroundImage: 'url("./cultura/Rrom.jpg")',
  backgroundColor: "#cccccc",
  height: "100%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 100%",
  position: "relative"
};

export default class Play extends Component { 
  state = {
    modal:false,
    count: 0,
    nextImage: 0,
    search: [
      {
        name: "Afro",
        imageUrl: 'url("./cultura/afro.jpg")',
        findDescription: ["El pez dorado de Catalina Luango", "Danzantes del lumbalú", "Las velas del ritual", "Hombre tocando el llamador", "La vasija que llevó Catalina Luango ", "Casa de Bahareque"],
        points: [
          {top: "40%", right: "55%", width: "8%", height: "8%"},
          {top: "75%", right: "75%", width: "10%", height: "10%"},
          {top: "82%", right: "45%", width: "10%", height: "10%"},
          {top: "70%", right: "60%", width: "10%", height: "10%"},
          {top: "54%", right: "38%", width: "12%", height: "12%"},
          {top: "40%", right: "80%", width: "14%", height: "14%"}
        ]
      },
      {
        name: "Raizal",
        imageUrl: 'url("./cultura/raizal.jpg")',
        findDescription: ["La araña o “Brother Anansi” ", "Las trenzas características de la mujer Raizal ", "El tambor usado en el calipso ", "Las mujeres danzando el calipso ", "El coco, fruta típica de la isla", "El mar de siete colores de SAI"],
        points: [
          {top: "40%", right: "26%", width: "10%", height: "10%"},
          {top: "18%", right: "57%", width: "12%", height: "12%"},
          {top: "47%", right: "75%", width: "12%", height: "12%"},
          {top: "33%", right: "75%", width: "10%", height: "10%"},
          {top: "57%", right: "22%", width: "8%", height: "8%"},
          {top: "90%", right: "10%", width: "80%", height: "8%", borderRadius: "8px"}
        ]
      },
      {
        name: "Rrom",
        imageUrl: 'url("./cultura/Rrom.jpg")',
        findDescription: ["Las cartas para las prácticas adivinatorias", "La “Black star” como amuleto", "Los pañuelos con monedas tipico del baile gitano", "Las campanas que protegen contra los espíritus ", "La copa, símbolo de gitano ", "Los amuletos de protección "],
        points: [
          {top: "52%", right: "50%", width: "8%", height: "8%"},
          {top: "90%", right: "53%", width: "8%", height: "8%"},
          {top: "16%", right: "50%", width: "8%", height: "8%"},
          {top: "88%", right: "90%", width: "8%", height: "8%"},
          {top: "33%", right: "15.5%", width: "10%", height: "10%"},
          {top: "75%", right: "45%", width: "8%", height: "8%"}
        ]
      },
      {
        name: "wayyuu",
        imageUrl: 'url("./cultura/wayuu.jpg")',
        findDescription: ["El chinchorro o hamaca ", "Wayuushein o (manta guajira)", "Iguaraya o (fruto cactus guajiro)", "El totem ", "El Acheepa o maquillaje facial Wayúu", "Tiara del vestuario del baile la Yonna"],
        points: [
          {top: "90%", right: "50%", width: "40%", height: "8%", borderRadius: "8px"},
          {top: "60%", right: "40%", width: "12%", height: "12%"},
          {top: "11%", right: "11.5%", width: "8%", height: "8%"},
          {top: "12%", right: "26%", width: "8%", height: "8%"},
          {top: "35%", right: "68.5%", width: "10%", height: "10%"},
          {top: "26%", right: "70%", width: "6%", height: "6%"}
        ]
      },
      {
        name: "Mokana",
        imageUrl: 'url("./cultura/mokana.jpg")',
        findDescription: ["Alimento tradicional en la gastronomía Mokaná (MAIZ)", "Piedra Pintá.", "Totumas", "Flechas.", "Elemento de protección", "Chorro de San Luis"],
        points: [
          {top: "88%", right: "88%", width: "10%", height: "10%"},
          {top: "33%", right: "15.5%", width: "10%", height: "10%"},
          {top: "57%", right: "50%", width: "8%", height: "8%"},
          {top: "30%", right: "40%", width: "8%", height: "8%"},
          {top: "30%", right: "61%", width: "8%", height: "8%"},
          {top: "15%", right: "45%", width: "8%", height: "8%"},
         

         
        ]
      }
    ]
  };
 
  hitPoint = (id) => {

    if (id !== this.state.count) return ;  
    let count = this.state.count + 1;
    if (count >= this.state.search[this.state.nextImage].points.length) {
      let nextImage = this.state.nextImage + 1;   
      if (nextImage > 4) {
        this.props.history.push('/game-over')
        return;
      }
      this.setState({modal:true,count: 0});
      return;
    }
    this.setState({count: count});
  };

  changeImage=()=>{
    this.setState({modal:false,nextImage:this.state.nextImage+1})
  }

  render() {
    return (
      <div className='pick-game-master'>
        <div className='image-container' style={{...heroImage, backgroundImage: this.state.search[this.state.nextImage].imageUrl}}>
        <div>{this.state.modal&&<Modal changeImage={this.changeImage}/>}</div>
          {this.state.search[this.state.nextImage].points.map((item, index) => (
            <label key={index} onClick={() => this.hitPoint(index)} className={`search-item ${this.state.count > index ? "lselect" : "lnot-select"}`} style={{...item}}>
              {index + 1}
            </label>
          ))}    
        </div>
        <div className='helper-container'>
          <div className='search-description'>
            <h6>Encuentra</h6>
            <h3>{this.state.search[this.state.nextImage].findDescription[this.state.count]}</h3>
          </div>

          <div className='card-images'>
            <img src='./cultura/afro.jpg' alt='tum' className={`mini-imagen ${this.state.nextImage === 0 ? "select" : "not-select"}`}></img>
            <img src='./cultura/raizal.jpg' alt='tum' className={`mini-imagen ${this.state.nextImage === 1 ? "select" : "not-select"}`}></img>
            <img src='./cultura/Rrom.jpg' alt='tum' className={`mini-imagen ${this.state.nextImage === 2 ? "select" : "not-select"}`}></img>
            <img src='./cultura/wayuu.jpg' alt='tum' className={`mini-imagen ${this.state.nextImage === 3 ? "select" : "not-select"}`}></img>
            <img src='./cultura/mokana.jpg' alt='tum' className={`mini-imagen ${this.state.nextImage === 4 ? "select" : "not-select"}`}></img>
          </div>
        </div>
      </div>
    );
  }
}
